<template>
  <div>
    <b-alert variant="danger"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div>

      <b-card>
        <div slot="header">
          Full Request Logs
        </div>
        <!-- User Interface controls -->
        <b-row>
          <b-col md="6" class="my-0">
            <b-form-group class="my-1">
              <b-input-group v-on:keyup.enter="LoadData" v-on:keyup.escape="ClearSearch">
                <!--v-on:keyup.esc="ClearSearch"-->
                <b-form-input @keydown.native="EscClearSearch" v-model="tbxFilter" id="tbxFilter" placeholder="Type to search by Dealership Id" />
                <b-input-group-append>
                  <b-btn class="btn btn-default text-white ml-2" @click="ClearSearch">
                    <i class="fa fa-eraser" title="Clear Search"></i> <strong class="text-white">Clear</strong>
                  </b-btn>
                  <b-btn class="btn btn-warning text-white ml-2" @click="LoadData">
                    <i class="fa fa-search" title="Search"></i> <strong class="text-white">Search</strong>
                  </b-btn>
                  <b-btn v-if="loggingEnabled" class="btn btn-default text-white ml-2" @click="ToggleLogging">
                    <i class="fa fa-default" title="Disable Logging"></i> <strong class="text-white">Disable Logging</strong>
                  </b-btn>
                  <b-btn v-else class="btn btn-default text-white ml-2" @click="ToggleLogging">
                    <i class="fa fa-default" title="Enable Logging"></i> <strong class="text-white">Enable Logging</strong>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>

          <b-col md="6" class="my-1"><div class="mr-2" style="text-align:right">Showing {{ GetRowCount() }} / {{ totalCount }} records</div></b-col>
        </b-row>
        <!-- Main table element -->
        <b-table id="tblMain" :items="FilteredRecords" hover striped bordered small :fields="fields" :current-page="currentPage" :per-page="perPage" :sort-compare="onSortChanged" show-empty>
          <template slot="PartnerAccountFullRequestLogId" slot-scope="row">
            {{row.value}}
          </template>
          <template slot="CreatedTS" slot-scope="row">
            {{row.value | formatDate}}
          </template>
          <template slot="show_details" slot-scope="row">
            <b-row class="px-2">
              <b-col md="12">
                <b-button @click.stop="row.toggleDetails" class="btn btn-info text-white btn-sm">
                  <i class="fa fa-info-circle"></i> <strong class="text-white">{{ row.detailsShowing ? 'Hide' : 'Show'}} Details</strong>
                </b-button>
              </b-col>
            </b-row>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card>
              <b-row>
                <b-col>
                  <strong>Request:</strong>
                  <br />
                  <div class="hljs wordwrap" v-html="Prettify(row.item.Request)"></div>
                  <!--<highlight-code lang="sql">{{row.item.Request}}</highlight-code>-->
                </b-col>
              </b-row>
              <br />
              <b-row v-if="row.item.ExtraInfo !== undefined && row.item.ExtraInfo.length>0">
                <b-col md="12">
                  <strong>Extra Info:</strong>
                  <br />
                  <div class="hljs wordwrap" v-html="Prettify(row.item.ExtraInfo)"></div>
                  <!--<highlight-code lang="csharp" inline>{{row.item.ExtraInfo}}</highlight-code>-->
                </b-col>
              </b-row>
              <br />
              <b-row>
                <b-col md="12">
                  <b-button class="btn btn-info text-white btn-sm" @click="row.toggleDetails">Hide Details</b-button>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
        <!-- NAV -->
        <nav>
          <b-pagination :total-rows="GetRowCount(Items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
        </nav>
      </b-card>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import axios from 'axios'
import loading from 'vue-full-loading'
import moment from 'moment'
import { setTimeout } from 'timers'
import HL from 'highlight.js'

export default {
  components: {
    loading
  },
  data () {
    return {
      loggingEnabled: true,
      modifiedBy: '',
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      txtLoading: 'Loading...',
      boolLoading: false,
      tbxFilter: undefined,
      intervalHandle: undefined,
      gettingData: false,
      gettingDataInterval: 5000,
      totalCount: 0,
      Items: [],
      itemsObject: {},
      fields: [
        { key: 'PartnerAccountFullRequestLogId', label: 'Full Request Code', sortable: true },
        { key: 'CreatedTS', label: 'Date', sortable: true },
        { key: 'DealershipId', label: 'Dealership Id', sortable: true },
        { key: 'ACCOUNT_NUMBER', label: 'Account number', sortable: true },
        { key: 'PartnerIdInt', label: 'Partner Id', sortable: true },
        { key: 'Method', label: 'Method', sortable: true },
        { key: 'show_details', label: '', sortable: false }
      ],
      currentPage: 1,
      perPage: 100,
      onSortChanged (a, b, key) {
        if (['accountLastRun', 'EXPIRATION_DATE'].indexOf(key) !== -1) {
          var a1
          var b1
          switch (key) {
            // case 'FUTUREUNKNOW':
            //  console.log(`${JSON.stringify(new Date())} (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}] (typeof a) ${(typeof a[key])} [${JSON.stringify(a[key])}]`);
            //  break;
            case 'CREATED_TS':
            case 'accountLastRun':
              a1 = moment(a[key])
              b1 = moment(b[key])

              if (a1.isValid() && b1.isValid()) {
                if (a1.isSame(b1)) {
                  return 0
                }
                if (a1.isAfter(b1)) {
                  return 1
                }
                return -1
              } else {
                if (a1.isValid()) {
                  return 1
                }
                if (b1.isValid()) {
                  return -1
                }
              }
              return 0
          }
        } else {
          if (typeof a[key] === 'number' && typeof b[key] === 'number') {
            // If both compared fields are native numbers
            return a[key] < b[key] ? -1 : (a[key] > b[key] ? 1 : 0)
          } else if (typeof a[key] === 'boolean' && typeof b[key] === 'boolean') {
            a1 = ((a[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            b1 = ((b[key] + '').toLowerCase().trim() === 'true') ? 1 : 0
            return a1 < b1 ? 1 : (a1 > b1 ? -1 : 0)
          } else {
            a1 = (a[key] + '')
            b1 = (b[key] + '')
            return (a1).localeCompare(b1)
          }
        }
      }
    }
  },
  created () {
    let self = this
    self.LoadData(true)
  },
  methods: {
    ToggleLogging() {
      const self = this
      let message = ""
      console.log(self.loggingEnabled)

      let newLogMode = false
      if (self.loggingEnabled === true) {
        newLogMode = false
        message = 'Smart logging disabled'
      }
      else {
        newLogMode = true
        message = 'Smart logging enabled'
      }

      let obj = {
        msg: message,
        modifiedBy: self.modifiedBy,
        newlogmode: newLogMode
      }

      let axiosConfig = {
        timeout: 60000
      }
      
      axios.post('/api/internal/SetRequestLogMode', obj, axiosConfig)
        .then(response => {
          self.errMsg = ''
          self.showDismissibleAlert = false

          self.loggingEnabled = response.data
        })
        .catch(error => {
          if (error !== undefined && error.response !== undefined && error.response.status === 403) {
            self.$router.push('/login')
          }
          self.errMsg = 'There was an error changing the log option : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
          self.showDismissibleAlert = true
        })
        
    },
    async LoadData (onCreated) {
      let self = this

      if (self.gettingData === false) {
        if (onCreated !== true) {
          self.boolLoading = true
        }

        self.gettingData = true

        let obj = {
          q: self.tbxFilter
        }

        let axiosConfig = {
          timeout: 60000
        }

        console.log("In Load Before change")
        console.log(self.loggingEnabled)

        await axios.post('/api/Internal/LoadFullRequestLog', obj, axiosConfig)
          .then(response => {
            self.errMsg = ''
            self.showDismissibleAlert = false

            self.totalCount = response.data.length
            self.Items = response.data
          })
          .catch(error => {
            if (error !== undefined && error.response !== undefined && error.response.status === 403) {
              self.$router.push('/login')
            }
            self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
            self.showDismissibleAlert = true
          }).then(response => {
            self.gettingData = false
            self.boolLoading = false
          })

        await axios.post('/api/Internal/GetRequestLogMode', obj, axiosConfig)
          .then(response => {
            self.errMsg = ''
            self.showDismissibleAlert = false

            self.loggingEnabled = response.data
          })
          .catch(error => {
            if (error !== undefined && error.response !== undefined && error.response.status === 403) {
              self.$router.push('/login')
            }
            self.errMsg = 'There was an error getting data : ' + ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
            self.showDismissibleAlert = true
          })

        await axios.get('/api/UserManagement/GetCurrent')
          .then(response => {
            self.boolLoading = false
            if (response.data === undefined || response.data === null) {
              self.user = {}
            } else {
              self.modifiedBy = response.data.name
            }
          })
          .catch(error => {
            if (error.response.status === 403) {
              self.$router.push('/login')
            }

            self.boolLoading = false
            self.errMsg = 'There was an error getting data : ' + error
            self.showDismissibleAlert = true
          })

        console.log("In Load After change")
        console.log(self.loggingEnabled)
      }
    },
    GetRowCount () {
      let self = this
      return self.FilteredRecords.length
    },
    ClearSearch () {
      let self = this
      self.tbxFilter = undefined
      self.LoadData()
    },
    EscClearSearch (event) {
      let self = this
      if (event.key === 'Escape') {
        self.ClearSearch()
      }
    },
    UNescapeHtml (str) {
      str = str.replace(/&amp;/g, '&')
      str = str.replace(/&lt;/g, '<')
      str = str.replace(/&gt;/g, '>')
      str = str.replace(/&quot;/g, '"')
      str = str.replace(/&#39;/g, "'")
      str = str.replace(/&#x2F;/g, '/')
      str = str.replace(/&#x60;/g, '`')
      str = str.replace(/&#x3D;/g, '=')
      str = str.replace(/&nbsp;/g, ' ')

      return str
    },
    escapeHtml (string) {
      var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
      }
      return String(string).replace(/[&<>"'`=\/]/g, function (s) {
        return entityMap[s]
      })
    },
    NewLiner (str) {
      if (str === undefined || str === null) {
        return ''
      }
      str = str.replace(/\r\n/g, '<br>')
      return str
    },
    SpaceRemover (str) {
      if (str === undefined || str === null) {
        return ''
      }
      str = str.replace(/ {8}/g, '&nbsp;')
      str = str.replace(/ {7}/g, '&nbsp;')
      str = str.replace(/ {6}/g, '&nbsp;')
      str = str.replace(/ {5}/g, '&nbsp;')
      str = str.replace(/ {4}/g, '&nbsp;')
      str = str.replace(/ {3}/g, '&nbsp;')
      str = str.replace(/ {2}/g, '&nbsp;')
      str = str.replace(/ /g, '&nbsp;')
      // str = str.replace(/:{/g, ':&lt;br&gt;{')
      // str = str.replace(/},/g, '},&lt;br&gt;')
      return str
    },
    Prettify (str) {
      if (str === undefined || str === null) {
        return ''
      }
      let self = this

      str = self.SpaceRemover(str)
      str = self.UNescapeHtml(str)

      let hlObject = HL.highlightAuto(str, ['cs', 'swift', 'csharp', 'xml', 'json', 'cmd'])

      str = hlObject.value
      return str
    }
  },
  filters: {
    formatDate: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        return m.add(moment().utcOffset(), 'm').format('MM/DD/YYYY hh:mm:ss a')
      }
      return ''
    },
    formatDateToNow: function (date) {
      var m = moment(date)
      if (m.isValid()) {
        let localTime = m.add(moment().utcOffset(), 'm')
        return localTime.toNow(true) + ' ago'
      }
      return ''
    }
  },
  computed: {
    FilteredRecords: function () {
      let self = this

      if (self.boolLoading) {
        return []
      } else {
        // if (self.tbxFilter !== undefined && self.tbxFilter !== null && self.tbxFilter.length > 0) {
        //  return self.Items.filter(u => (u.account + '').toLowerCase().includes(self.tbxFilter.toLowerCase()) ||
        //      (u.accountName + '').toLowerCase().includes(self.tbxFilter.toLowerCase()))
        // } else {
        return self.Items
        // }
      }
    }
  },
  mounted () {
    let self = this

    self.boolLoading = true
  }
}
</script>

<style type="text/css">
  .hljs {
    background: transparent;
  }

  .wordwrap {
    font-size: 87.5%;
    white-space: pre-wrap; /* CSS3 */
    white-space: -moz-pre-wrap; /* Firefox */
    white-space: -pre-wrap; /* Opera <7 */
    white-space: -o-pre-wrap; /* Opera 7 */
    word-wrap: break-word; /* IE */
  }
</style>



// WEBPACK FOOTER //
// src/views/FullRequestLogs.vue